import React from "react";

function NotFound() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
        width: "100vw",
      }}
    >
      <h1 style={{ fontSize: "4rem", marginBottom: "1rem" }}>404</h1>
      <h2 style={{ fontSize: "2rem", marginBottom: "2rem" }}>Page Not Found</h2>
      <p style={{ fontSize: "1.2rem", color: "#666" }}>
        The page you are looking for doesn't exist or has been moved.
      </p>
    </div>
  );
}

export default NotFound;
